import {config} from 'config/env';

export const CREATE_USER_ADDRESS = `
  mutation createUserAddress($createAddressInput: CreateAddressInputType!) {
    createUserAddress(createAddressInput: $createAddressInput) {
      id
    }
  }
`;
export const GET_USER_ADDRESSES = `
  query getUserAddresses($addressType: String) {
    getUserAddresses(addressType: $addressType) {
      id
      address1
      address2
      country
      firstName
      lastName
      mobile
      company
      longitude
      latitude
      user_longitude
      user_latitude
      deliveryInstructions
      ${config.IS_ENABLE_LOCUS_LAT_LONG ? 'locus_latitude' : ''}
      ${config.IS_ENABLE_LOCUS_LAT_LONG ? 'locus_longitude' : ''}
      isEligibleForExpress
      subDistrict {
        id
        nameTh
        nameEn
      }
      isDefault
      province {
        id
        nameTh
        nameEn
      }
      district {
        id
        nameTh
        nameEn
      }
      zip
      taxId
      branchId
      email
      metadata {
        zoomLevel
        distanceKm
        locusDistanceKm
      }
    }
  }
`;

export const GET_USER_DETAILS = `
  query getUserDetails {
    getUserDetails {
      id
      firstName
      lastName
      displayName
      email
      mobile
    }
  }
`;

export const UPDATE_USER_ADDRESS = `
  mutation updateUserAddress($addressId: String!, $updateAddressInput: UpdateAddressInputType!, $addressType: String) {
    updateUserAddress(addressId: $addressId, updateAddressInput: $updateAddressInput, addressType: $addressType) {
      id
    }
  }
`;

export const MARK_ADDRESS_DEFAULT = `
  mutation markAddressAsDefault($addressId: String!) {
    markAddressAsDefault(addressId: $addressId) {
      id
    }
  }
`;

export const GET_STORE_AREAS = `
  query getStoreAreas($filter: ThailandAreaInput, $suggestion: ThailandAreaInput, $pageNo: Float, $pageLength: Float) {
    getStoreAreas(filter: $filter, suggestion: $suggestion, pageNo: $pageNo, pageLength: $pageLength) {
      s
      p
      d
      z
      se
      de
      pe
      status
      sID
      dID
      pID
      st
    }
  }
`;

export const SYNC_MEMBERSHIP_CARDS = `
  query syncMakroMembershipCards {
    syncMakroMembershipCards {
      id
      cardNumber
      isDefault
      isLinked
      nameTh
      isNew
    }
  }
`;

export const GET_MEMBERSHIP_CARDS_WITH_POINTS = `
  query getMakroMembershipCards {
    getMakroMembershipCards {
      id
      cardNumber
      isDefault
      isLinked
      nameTh
      status
      alcoholExpiryDate
      name
      businessType
      alcoholOtpn
    }
  }
`;

export const GET_SUB_DISTRICTS = `
  query getStoreAreas($filter: ThailandAreaInput, $suggestion: ThailandAreaInput, $pageNo: Float, $pageLength: Float) {
    getStoreAreasV2(filter: $filter, suggestion: $suggestion, pageNo: $pageNo, pageLength: $pageLength) {
      result {
        de
        dID
        se
        sID
        z
        pe
        p
        s
        pID
        d
        status
      }
      pageCount
    }
  }
`;
